export default "__VITE_ASSET__8588c00b__"